/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @angular-eslint/prefer-inject */
import { Component } from '@angular/core';
import { DefectHistoryConstants } from '../models/constants/defect-history.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { ActiveFiltersComponent } from 'src/app/shared/filtering';
import { DefectDetailViewComponent } from "../defect-detail-view/defect-detail-view.component";
import { DefectListViewComponent } from '../defect-list-view/defect-list-view.component';
import { DefectHistoryModel } from '../models/defect-history.model';
import { panelSlider } from 'src/app/shared/content-panels/animations';
import { MatIconModule } from '@angular/material/icon';


@Component({
  selector: 'app-defect-view-container',
  imports: [
    ActiveFiltersComponent,  
    DefectDetailViewComponent,
    MatIconModule,
    DefectListViewComponent
  ],
  templateUrl: './defect-view-container.component.html',
  styleUrl: './defect-view-container.component.scss',
  animations: [panelSlider],
})
export class DefectViewContainerComponent {
  isDetailOpen = false;
  serial: DefectHistoryModel | null = null;

  breadCrumbTextHome = this.defectHistoryConstants.cqmsBreadCrumbText;
  breadCrumbTextDefectHistory = this.defectHistoryConstants.defectHistoryBreadCrumbText;

  //dialog data
  id = 0;
  startDate: Date | null = null;
  endDate: Date | null = null;
  facilityNumber = '';

  constructor(
    private route: ActivatedRoute, 
    private router: Router, 
    public defectHistoryConstants: DefectHistoryConstants
  ) {}

  ngOnInit() {
    const facilityData = localStorage.getItem('userFacilities');
    if (facilityData) {
      const facilities = JSON.parse(facilityData);
      const primary = facilities[0];
      this.facilityNumber = primary?.Facility?.KeyChain?.LegacyId ?? '';
    }

    this.route.queryParams.subscribe(params => {
      this.startDate = params['startDate'] ? new Date(params['startDate']) : null;
      this.endDate = params['endDate'] ? new Date(params['endDate']) : null;
    });
  }

  navigateToDashboard() {
    this.router.navigate(['/cqms-dashboard']);
  }

  selectSerial(serial: DefectHistoryModel) {
    this.serial = serial;
    this.isDetailOpen = true;
  }

  closeDetail() {
    this.serial = null;
    this.isDetailOpen = false;
  }

}
